import { ButtonComponentConfig } from '../button/button-component-config.interface';

export interface CardSevenButtonOutput {
    button: ButtonComponentConfig;
    data: any;
}
